import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Alert from 'components/Alert';
import { ProfileContext } from 'context';
import { useAction } from 'hooks/useAction';
import * as selectors from '../../selectors';
import * as actions from '../../actions';
import messages from '../../messages';
const VisitsHistory = ({ mode, children, onShowNotes })=>{
    const [currentPage, setPage] = useState(0);
    const profileContext = useContext(ProfileContext);
    const isFetchVisitsMetadataInProgress = useSelector(selectors.isFetchVisitsMetadataInProgress);
    const isFetchVisitMetadataInProgress = useSelector(selectors.isFetchVisitMetadataInProgress);
    const prvKeyPem = useSelector(profileContext.selectors.prvKeyPem);
    const passphrase = useSelector(profileContext.selectors.passphrase);
    const phiSet = useSelector(profileContext.selectors.phiSet);
    const visitHistoryActiveVisit = useSelector(profileContext.selectors.visitHistoryActiveVisit);
    const onFetchVisitsMetadataAction = useAction(actions.fetchVisitsMetadata);
    const visitsList = [
        ...(phiSet === null || phiSet === void 0 ? void 0 : phiSet.visits) || []
    ].reverse();
    const phiSetVisits = visitHistoryActiveVisit ? visitsList.filter((visit)=>visit.phisetVisitId !== visitHistoryActiveVisit.phisetVisitId) : visitsList;
    const onFetchVisitsMetadataPage = ({ page = 0, perPage = 5 } = {})=>{
        if (!phiSetVisits.length) return;
        const visitsToFetch = phiSetVisits.slice(perPage * page, perPage * (page + 1));
        onFetchVisitsMetadataAction(visitsToFetch, prvKeyPem, passphrase);
        setPage(page);
    };
    useEffect(()=>{
        onFetchVisitsMetadataPage();
    }, [
        phiSet
    ]);
    if (!phiSetVisits || !phiSetVisits.length) {
        const infoKey = mode === 'HCP' ? 'noVisits' : 'noVisitsPwd';
        return /*#__PURE__*/ _jsx(Alert, {
            type: "info",
            message: messages.infos[infoKey]
        });
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children({
            phiSetVisits,
            page: currentPage,
            perPage: 5,
            isInProgress: isFetchVisitsMetadataInProgress || isFetchVisitMetadataInProgress,
            onPageChange: (pageChangeArgs)=>onFetchVisitsMetadataPage({
                    page: pageChangeArgs.page,
                    perPage: pageChangeArgs.perPage
                }),
            onShowNotes
        })
    });
};
export default VisitsHistory;
